import { Image } from "materials/image/menus/model"
export class Swiper {
  constructor(difference) {
    this.isDefaultComponent = true
    this.styleId = 1
    this.width = 1200
    this.height = 500
    this.name = "轮播"
    this.swiperButtonType = "button_style2"
    this.swiperMode = false
    this.buttonTop = 0
    this.buttonLeft = 0
    this.innerElement = "swiperComponent"
    this.isActive = false
    this.showButton = true
    this.buttonIconClassName = "icon-portal-arrow1"
    this.buttonIconSize = 24
    this.buttonIconColor = "rgba(0, 0, 0, 0.6)"
    this.buttonIconShowBackGround = true
    this.buttonIconBackgroundColor = "#FFFFFF"
    this.buttonIconBackgroundWidth = 32
    this.buttonIconBackgroundHeight = 32
    this.buttonIconBackGroundBorderRadius = 16
    this.buttonIconCustomTop = false
    this.buttonIconPadding = 20
    this.buttonIconTop = 20
    this.iconSrc = "FCDE54BF21DDAE3D"
    this.iconColorIsThemeColor = false
    this.iconBgIsThemeColor = false
    this.direction = "horizontal" //水平切换(horizontal)垂直切换(vertical)。
    this.speed = 600
    this.loop = true
    this.autoplay = false
    this.freeMode = true
    this.slidesPerView = 1
    this.centeredSlides = true
    this.progressbarHeight = 6
    this.fadeEffect = {
      crossFade: true
    }
    this.cubeEffect = {
      slideShadows: true,
      shadow: true,
      shadowOffset: 100,
      shadowScale: 0.6
    }
    this.coverflowEffect = {
      rotate: 15,
      stretch: 0,
      depth: 70,
      modifier: 2,
      slideShadows: true
    }
    this.flipEffect = {
      slideShadows: true,
      limitRotation: true
    }

    this.paginationPosition = "bottom"
    this.bulletsSize = 20
    this.bulletsMargin = 10
    this.rotate = 0
    this.progressbarBackground = "rgb(0,122,255)"
    this.pagination = {
      type: "bullets", //‘bullets’  圆点（默认）,‘fraction’  分数， ‘progressbar’  进度条
      clickable: true, //点击切换,
      bulletsPrimaryColor: "rgba(0,0,0,0.2)",
      bulletsActiveColor: "rgb(0,122,255)"
    }
    this.navigation = {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
    this.effect = "slide"
    this.swiperBackground = [
      {
        swiperContent_id: 0,
        type: "img",
        label: "图片",
        imgUrl:
          "https://p.ananas.chaoxing.com/star3/origin/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      },
      {
        swiperContent_id: 1,
        // type: "video",
        // label: "视频",
        // imgUrl: "https://p2.ananas.chaoxing.com/sv-w9/video/b8/0b/d5/fce23232706dc54b80bf0a475a8fd9d9/snapshot.jpg",
        // videoUrl: "https://s1.ananas.chaoxing.com/sv-w9/video/b8/0b/d5/fce23232706dc54b80bf0a475a8fd9d9/sd.mp4?at_=1670920037543&ak_=df95011121276fd90c2efbd3e93c41c1&ad_=ffd9426ea3b9bb031e972b3185ba8594",
        // videoCache: true,
        // loopPlay: true,
        type: "img",
        label: "图片",
        imgUrl:
          "https://p.ananas.chaoxing.com/star3/origin/e70316aaef51d94d17b1874630e5e448.png?rw=1920&rh=1537&_fileSize=657446&_orientation=1",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      },
      {
        swiperContent_id: 2,
        type: "img",
        label: "图片",
        imgUrl:
          "https://p.ananas.chaoxing.com/star3/1920_785Q50/5c33b3f7be52743d475ae4030a12c18f.png?rw=1920&rh=785&_fileSize=371938&_orientation=1",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      }
    ] // 轮播页背景图
    //以下是非swiper官方api，自定义属性
    this.content = [
      {
        swiperContent_id: 0,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc: "https://p.ananas.chaoxing.com/star3/origin/bb12fe28483d17dc8f8beb0ec5e247f9.png",
              width: 414,
              height: 150,
              left: 0,
              top: 0
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 1,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc: "https://p.ananas.chaoxing.com/star3/origin/9f8b2497804f617911dee951d48ea00a.png",
              width: 414,
              height: 150,
              left: 0,
              top: 0
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 2,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc: "https://p.ananas.chaoxing.com/star3/origin/4b82e2b12ee56f5ca823c1fda6047fb3.png",
              width: 414,
              height: 150,
              left: 0,
              top: 0
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      }
    ]
    this.borderStyle = "solid"
    this.borderWidth = 0
    this.boxShadowColor = []
    this.boxShadowH = []
    this.boxShadowV = []
    this.boxShadowBlur = []
    this.boxShadowSpread = []
    this.buttonBoxShadowColor = ["rgba(0, 0, 0, 0.1)"]
    this.buttonBoxShadowH = [0]
    this.buttonBoxShadowV = [4]
    this.buttonBoxShadowBlur = [12]
    this.buttonBoxShadowSpread = [0]
    this.iconResInfo = {
      name: "箭头"
    }
    this.updateTimer = null // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.usePageQuery = false //页面传参
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
